import {observer, useLocalObservable} from "mobx-react";
import React, {useEffect} from 'react'
import styled from "styled-components";
import {useForm} from "react-hook-form";
import Page from "../../components/Pages/Page";
import FormInput from "../../components/Inputs/FormInput/FormInput";
import Button from "../../components/Button";
import MainSelect from "../../components/Selects/MainSelect/MainSelect";
import DateRangePicker from "../../components/Inputs/DateRangePicker/DateRangePicker";
import {cleanPhoneMask} from "../../utils/utils";
import FormAttention from "../../components/FormAttention";
import LinkCell from "../../components/Pages/TablePage/Table/Cells/LinkCell/LinkCell";
import {Link} from 'react-router-dom'
import SocketStore from "../../stores/socket.store";


type BookingTemplate = {
  questions?: Array<{ question: string, answer: string }>,
  submit: ({}: any) => {},
  complete?: boolean,

}

const BookingTemplate = observer((props: BookingTemplate) => {


  const store = useLocalObservable(() => ({
    form: {
      date: [{
        startDate: new Date(),
        endDate: null,
        key: 'selection'
      }],
      amount: "",
      phone: "",
      contactsFio: "",
      address: "",
      type: ""
    },
    setDate: (date) => store.form.date = date,
    setForm: (key, value) => store.form = {...store.form, [key]: value},
    //questions
    selectedQuestion: props?.questions[0]?.question,
    setSelectedQuestion: (question: string) => store.selectedQuestion = question,
    errors: [],
    setErrors: (errors) => store.errors = errors,
    prepare: (form) => ({
      ...form,
      dates: [{
        startDate: form?.date[0]?.startDate,
        endDate: form?.date[0]?.endDate ? form?.date[0]?.endDate : form?.date[0]?.startDate
      }],
      contactsPhone: cleanPhoneMask(form.phone),
    })
  }))


  const submit = () => {
    validate(store.form)
    if (store.errors.length === 0)
      props.submit(store.prepare(store.form))

  }
  const validate = (form) => {
    let errors = []
    !form.type && errors.push("Укажите тип исследования")
    !form.amount && errors.push("Укажите количество сотрудников")
    !form.phone && errors.push("Укажите контактный номер")
    form.phone && cleanPhoneMask(form.phone).length !== 12 && errors.push("Неправильный контакатный номер")
    !form.contactsFio && errors.push("Укажите тип ФИО ответстевенного")
    !form.address && errors.push("Укажите адрес")
    !form.date[0]?.startDate && errors.push("Укажите дату")
    store.setErrors(errors)
  }


  return (
    <Page>
      <Styled>
        <div className="header">
          <div className="title">Бронирование</div>
        </div>
        <div className="main">
          <div className="form">
            <div className="errors">
              {store.errors[0] && <FormAttention error={store.errors[0]}/>}
            </div>
            {props.complete
              ? (
                <div className="completed">
                  <p>Спасибо! Ваша заявка принята и направлена удостоверяющим центрам. <br/>
                    Следите за актуальностью заявки в  <Link
                      to={process.env.REACT_APP_URL_PREFIX + '/notifications'}>уведомлениях</Link>.</p>
                </div>
              )
              : (<>
                <div className="row">

                  <div className="selectt">
                    <MainSelect placeholder="Вид исследований"
                                bg="#F0F8FF"
                                border="1px solid #BCE0FD"
                                width="100%"
                                fontWeight="normal"
                                onChange={item => store.setForm("type", item.label)}
                                options={[{label: 'Флюорография'}]}
                                hideIcon/>
                  </div>

                  <FormInput onChange={e => store.setForm('amount', e.target.value)}
                             placeholder={'Сколько сотрудников'}
                             type="number"
                             hideIcon/>

                  <FormInput
                    hideIcon
                    placeholder={'Контактный номер'}
                    useNumberFormat={true}
                    name={'phone'}
                    format='+#(###)###-##-##'
                    allowEmptyFormatting={false}
                    mask={'_'}
                    onChange={e => store.setForm('phone', e.target.value)}
                  />
                  <FormInput onChange={e => store.setForm('contactsFio', e.target.value)} placeholder={'ФИО ответственного'}
                             hideIcon/>
                </div>

                <div className="row">
                  <DateRangePicker bg={"#F0F8FF"} onChange={store.setDate} value={store.form.date} hideIcon/>
                  <FormInput onChange={e => store.setForm('address', e.target.value)} placeholder={'Адрес'} class={"address"} hideIcon/>
                  <div className="buttons">
                    <Button onClick={submit} text={"Отправить"}/>
                  </div>
                </div>

              </>)}


          </div>
        </div>
        <div className="footer">
          <div className="title">
            Мы помогаем найти самые выгодные предложения.
          </div>
          <div className="main">
            <div className="questions">
              <div className="title">Ответы на вопросы</div>
              <ul>
                {props.questions.map(item => <li onClick={_ => store.setSelectedQuestion(item.question)}
                                                 style={{textDecoration: store.selectedQuestion === item.question ? "underline" : ""}}>{item.question}</li>)}
              </ul>
            </div>
            <div className="answer">
              {props.questions.map(item => item.question === store.selectedQuestion && item.answer)}
            </div>
          </div>
        </div>
      </Styled>
    </Page>

  )
})


const Styled = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  z-index: 1111111111;
  .header {
    width: 100%;
    display: flex;
    justify-content: center;
    min-height: 90px;
    align-items: flex-end;

    .title {
      font-weight: normal;
      font-size: 30px;
    }
  }

  .main {
    padding: 0 7%;

    .form {

      display: flex;
      flex-direction: column;

      .completed {
        font-size: 30px;
        text-align: center;
        p {
          font-weight: normal;

        }
        a {
          color: #3b99fc;
        }
      }

      .errors {
        height: 83px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .error {
          background: red;
        }
      }

      .row {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 28px;

        * {
          input {
            &::placeholder {
              color: black;
              font-weight: normal;
            }
          }
        }

        .DateRangePicker {
          width: 20%;

          .DateRangePicker__calendar {
            border: 1px solid #BCE0FD;
          }

          .input {
            border: 1px solid #BCE0FD;
            color: black;
            font-weight: normal;

            * {
              font-weight: normal;

            }
          }
        }

        .selectt {
          width: 20%;
        }

        .form__option {
          width: 20% !important;
          margin-bottom: 0;

          input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
          }

        }

        .address {
          width: 46.6% !important;
        }

        .buttons {
          width: 20%;
          display: flex;
          justify-content: center;
        }
      }
    }
  }

  .footer {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    justify-content: flex-end;
    height: 100%;

    .title {
      font-size: 25px;
      font-weight: normal;
      margin-bottom: 40px;
    }

    .main {
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding-bottom: 90px;

      .questions {
        width: 40%;
        height: 300px;
        background: #D9E2F8;
        border-radius: 20px;

        li {
          cursor: pointer;
          font-size: 18px;
        }

        * {
          font-weight: normal;
        }

        padding: 27px 60px;

        .title {
          font-weight: normal;
          font-size: 20px;
        }
      }

      .answer {
        width: 55%;
        font-size: 18px;
        font-weight: normal;
      }
    }
  }
`

export default BookingTemplate